import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  template: require('./license-agrement.component.html'),
  styles: [require('./license-agrement.component.less')],
  preserveWhitespaces: true
})
export class LicenseAgrementComponent {

  passwordDetails: any = {};
  valueRequired: boolean = false;
  key: string;
  private _userRole: string;
  isValid: boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
  }

  close () {
    window.close();
  }
}
